<div class="vertical basic-card padding">
  <div class="horizontal">
    <div class="status-dot" [ngClass]="data?.status"></div>
    <app-board-icon [board]="data?.board"></app-board-icon>
    <div>{{ data?.startDateTime | toLocaleFormat: 'LLL dd' }} - {{ data?.endDateTime | toLocaleFormat: 'LLL dd' }}</div>
  </div>
  <div class="horizontal">
    <div class="vertical">
      <div class="horizontal">
        <div class="statistic-card">
          <h2>{{ data?.pendingInvitationsCount }}</h2>
          <p>Pending</p>
        </div>

        <div class="statistic-card">
          <h2>{{ data?.sentInvitationsCount }}</h2>
          <p>Sent invitations</p>
        </div>

        <div class="statistic-card">
          <h2>{{ data?.acceptedInvitationsCount }}</h2>
          <p>Accepted Invitations</p>
        </div>

        <div class="statistic-card">
          <h2>{{ data?.repliedMessageCount }}</h2>
          <p>Answered Message</p>
        </div>
      </div>

      <div class="horizontal">
        <div echarts [options]="data?.invitationFunnelOption" class="funnel-chart"></div>
        <div echarts [options]="data?.industryPieOption" class="pie-chart"></div>
        <div echarts [options]="data?.productPieOption" class="pie-chart"></div>
      </div>
    </div>
  </div>
</div>
